import http from "@/http-common";

/* eslint-disable */
class GradeDataService {
  getGradeInfo(vin: string): Promise<any> {
    return http.api.get(`/getGradeInfo/${vin}`)
  }
}
export default new GradeDataService();
